import {ReactNode} from 'react'
import './Typography.scss'

export const CardTitle = ({title, children}: { title: string, children?: ReactNode }) => {
    return <h4 className="card-title" title={title}>{children ? children : title}</h4>
}